<script setup lang="ts">
import { GroupedItems } from './navigation-items.types';
import NavigationItemComponent from './navigation-item.vue';

defineProps<{
  groupKey: string;
  groups: GroupedItems;
  level?: number;
}>();
</script>

<template>
  <NavigationItemComponent
    v-for="item in groups.get(groupKey)"
    :key="item.key"
    :item="item"
    :groups="groups"
    :level="level || 0"
  />
</template>
